import i18next from 'i18next';
import React from 'react';
import { bool, func } from 'prop-types';

import Button from '~components/Button';

import styles from './styles.module.scss';

// Way out to the manual flow: a link while ClaveÚnica can still work, the main
// action once it can't (blocked account, too many codes or ClaveÚnica down).
function ManualExit({ primary, handleManualChoice }) {
  if (primary) {
    return (
      <Button primary className={styles.manualButton} onClick={handleManualChoice}>
        {i18next.t('ClientUniqueKeyLogin:manualContinue')}
      </Button>
    );
  }
  return (
    <button type="button" className={styles.manualLink} onClick={handleManualChoice}>
      {i18next.t('ClientUniqueKeyLogin:manualExit')}
    </button>
  );
}

ManualExit.propTypes = {
  handleManualChoice: func,
  primary: bool
};

export default ManualExit;
